import styled from 'styled-components';
import { IonLoading, IonModal, isPlatform } from '@ionic/react';

type StyledVideoCallContainerProps = {
  isBlurred: boolean;
  isScreenShare: boolean;
};

export const StyledVideoCallContainer = styled.div<StyledVideoCallContainerProps>`
  width: 100%;
  height: 100%;
  background-color: #000000;
  padding: ${isPlatform('hybrid') ? 'var(--ion-safe-area-top)' : '16px'} 16px
    ${isPlatform('hybrid') ? 'var(--ion-safe-area-bottom)' : '16px'} 16px;
  display: flex;
  flex-direction: column;
  filter: ${({ isBlurred }) => (isBlurred ? 'blur(3px)' : 'none')};

  @media screen and (min-width: 1024px) {
    padding: ${isPlatform('hybrid') ? 'var(--ion-safe-area-top)' : '40px'} 40px
      ${isPlatform('hybrid') ? 'var(--ion-safe-area-bottom)' : '40px'} 40px;
  }
  color: #fff;
`;

type MainMediaPlayerContainerProps = {
  isScreenShare: boolean;
};

export const MainMediaPlayerContainer = styled.div<MainMediaPlayerContainerProps>`
  position: relative;
  width: 100%;
  height: 100%;
  background: rgba(48, 48, 48, 0.55);
  border-radius: 10px;

  @media screen and (min-width: 1024px) {
    width: ${({ isScreenShare }) => (isScreenShare ? '75%' : '100%')};
  }
`;

export const MediaPlayersContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  @media screen and (min-width: 1024px) {
    flex-direction: row;
    gap: 20px;
  }
  @media screen and (orientation: landscape) {
    flex-direction: row;
  }
`;

export const MediaPlayersSideBar = styled.div`
  width: 100%;
  height: 30%;
  display: flex;
  flex-direction: row;
  gap: 12px;
  @media screen and (min-width: 1024px) {
    width: 25%;
    flex-direction: column;
    gap: 20px;
    height: 100%;
  }
  @media screen and (orientation: landscape) {
    flex-direction: column;
    height: 100%;
    width: 25%;
  }
`;

export const MediaPlayerSidebarItem = styled.div`
  width: 100%;
  height: 100%;
  background: rgba(48, 48, 48, 0.55);
  border-radius: 10px;
  @media screen and (min-width: 1024px) {
    height: 50%;
  }
`;

export const LocalMediaPlayerContainer = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  height: 27%;
  width: calc(31% + 32px);
  background: #323232;
  border-radius: 10px;
  overflow: hidden;
  @media screen and (orientation: landscape) {
    height: 32%;
    width: 24%;
  }
  @media screen and (min-width: 1024px) {
    width: 24%;
    height: 23%;
  }
`;

export const StyledVideoCallMask = styled.div`
  width: 100%;
  height: 100%;
  z-index: 2;
  background: black;
  opacity: 0.4;
  position: absolute;
`;

export const StyledInformationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  gap: 10px;

  text-align: center;

  position: absolute;
  top: calc(74px + env(safe-area-inset-top));
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 3;
`;

export const StyledMainBlockHeading = styled.h1`
  color: #ffffff;

  margin-bottom: 10px;

  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
`;

export const StyledMainBlockImage = styled.img`
  object-fit: cover;
  height: 100%;
  left: 50%;
  transform: translate(-50%, 0);
  position: absolute;
`;

export const StyledIonLoading = styled(IonLoading)`
  z-index: 3;
`;

export const StyledVideoCallSwitchDeviceModal = styled(IonModal)`
  &::part(content) {
    --background: #1d201f;

    color: white;
    width: auto;
    height: auto;

    max-width: 70%;

    border-radius: 10px;
  }

  &::part(backdrop) {
    backdrop-filter: blur(8px);
  }
`;

type StyledParticipantContainerPropsType = {
  participantsCount: number;
};

export const StyledParticipantContainer = styled.div<StyledParticipantContainerPropsType>`
  width: 100%;
  height: 100%;

  transition: 200ms ease-in-out;

  display: grid;
  grid-template-columns: ${({ participantsCount }) => `repeat(${Math.ceil(participantsCount / 2)}, 1fr)`};
  grid-template-rows: ${({ participantsCount }) => (participantsCount > 1 ? '1fr 1fr' : '1fr')};
  grid-gap: 10px;
  grid-auto-flow: dense;
`;
